export const LAST_CONNECTION = "LASTCONNECTION";
export const ABORTED = "ABORTED";
export const DISCONNECTED = "DISCONNECTED";
